// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "85b422e";
